import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PATHS } from 'src-ironside/app-routing.module';

export enum fromPATH {
    accueil = 'home',
    blank = 'blank',
    supplier = 'supplier',
    header = 'header',
    marque = 'marque',
};

export type ScreenMediatorHistory = {
    name: string;
    url: string;
};

@Injectable({ providedIn: 'root' })
export class ScreenMediator {
    private _history: ScreenMediatorHistory[] = [];
    constructor(private router: Router) {}
    toHome() {
        this.clearHistory();
        this.router.navigate([`${PATHS.home}`]);
    }

    toCatalogue() {
        this._history.push({ name: 'Catalogue produits', url: `${PATHS.catalogues_en}` });
        this.router.navigate([`${PATHS.catalogues_en}`]);
    }

    toRecherche() {
        this._history.push({ name: 'research', url: `${PATHS.research}` });
        this.router.navigate([`${PATHS.research}`]);
    }

    toFournisseurDetail(code: string, name?: string, url?:string) {
        this._history.push({
            name: `${name}`,
            url: `${PATHS.suppliers_en}/${url}/${code}`,
        });
        this.router.navigate([`${PATHS.suppliers_en}/${url}/${code}`]);
    }

    toMarqueDetail(code: string, name?: string) {
        this._history.push({
            name: `${name}`,
            url: `${PATHS.gestion_marques}/detail/${code}`,
        });
        this.router.navigate([`${PATHS.gestion_marques}/detail/${code}`]);
    }

    toPartnerDetail(code: string, name?: string) {
        this._history.push({
            name: `${name}`,
            url: `${PATHS.partners_en}/detail/${code}`,
        });
        this.router.navigate([`${PATHS.partners_en}/detail/${code}`]);
    }

    toProductDetail(id: string) {
        this.router.navigate([`${PATHS.product_en}/detail/${id}`]);
    }

    toNewsDetail(id: string) {
        this.router.navigate([`${PATHS.news}/${id}`]);
    }

    user = {
        changePassword : () => {
            this.router.navigate([PATHS.modifyPassword]);            
        }
    }

    clearHistory() {
        this._history = [];
    }

    putHistory(data: ScreenMediatorHistory) {
        this._history.push(data);
    }

    get history() {
        return this._history;
    }
}
